/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Knp_Lookup_Delete_Terms_TextInputs */

const en_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}}? This action cannot be undone.`)
};

const fr_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer ${i?.count} terme${i?.["count, plural, one {"]} other ${i?.s}} ? Cette action est irreversible.`)
};

const de_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`)
};

const it_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi davvero eliminare ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}}? Questa azione non può essere annullata.`)
};

const ru_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}}? Это действие необратимо.`)
};

const es_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Seguro que desea eliminar el término ${i?.count}, ${i?.["count, plural, one {"]} other ${i?.s}}? Esta acción no se puede deshacer.`)
};

const zh_cn2_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除${i?.count}术语${i?.["count, plural, one {"]} other ${i?.s}}吗？此操作无法撤销。`)
};

const ja_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}} を削除してもよろしいですか? この操作は元に戻せません。`)
};

const hi_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई ${i?.count} टर्म${i?.["count, plural, one {"]} other ${i?.s}} को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।`)
};

const pt_pt2_knp_lookup_delete_terms_text = /** @type {(inputs: Knp_Lookup_Delete_Terms_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o termo ${i?.count}_${i?.["count, plural, one {"]} other ${i?.s}}? Esta ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} term{count, plural, one {} other {s}}? This action cannot be undone." |
*
* @param {Knp_Lookup_Delete_Terms_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_terms_text = /** @type {((inputs: Knp_Lookup_Delete_Terms_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Terms_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_delete_terms_text(inputs)
	if (locale === "de") return de_knp_lookup_delete_terms_text(inputs)
	if (locale === "it") return it_knp_lookup_delete_terms_text(inputs)
	if (locale === "ru") return ru_knp_lookup_delete_terms_text(inputs)
	if (locale === "es") return es_knp_lookup_delete_terms_text(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_delete_terms_text(inputs)
	if (locale === "ja") return ja_knp_lookup_delete_terms_text(inputs)
	if (locale === "hi") return hi_knp_lookup_delete_terms_text(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_delete_terms_text(inputs)
	return en_knp_lookup_delete_terms_text(inputs)
});